/**
 * Creates a table dto that is displayed in the table
 */
export class TableDto {
    public _id?: number;
}